import { EqualityFn } from 'react-redux';
import { Setting } from '../../common/types/settings';
import settingsSelectors from '../../settings/settingsSelector';
import { Store } from '../../store';

export const getGroups = (
  useSelector: (selector: (state: Store) => Setting[], equalityFn?: EqualityFn<Setting[]>) => Setting[]
): Setting[] => {
  return useSelector(settingsSelectors.getGroups);
};
